import type {
  DefaultMenuItem,
  GetMainMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-enterprise';
import { getResetColumnsMenuItem } from '../columns/resetColumnsMenuItem';
import type { ReferenceInventoryContext, ReferenceInventoryRow } from './types';

const getNoFieldOrder = (): ReadonlyMap<string, number> => new Map();

export const getReferenceColumnMainMenuItems = ({
  api,
  context,
  defaultItems,
}: GetMainMenuItemsParams<ReferenceInventoryRow, ReferenceInventoryContext>): (
  | DefaultMenuItem
  | MenuItemDef<ReferenceInventoryRow>
)[] =>
  defaultItems.map(item => {
    if (item !== 'resetColumns') return item;
    return getResetColumnsMenuItem({
      api,
      i18nLocale: context.i18nLocale,
      defaultVisibleColumnKeys: context.defaultVisibleColumnKeys,
      getFieldOrderByColumnKey: getNoFieldOrder,
    });
  });
